<template>
  <div class="cn-footer-menu">
    <div v-for="item in menu" :key="item.id" class="cn-footer-menu__item">
      <div class="cn-footer-menu__item-title">
        {{ item.name }}
      </div>
      <ul class="cn-footer-menu__item-list">
        <li v-for="child in item.children" :key="child.id">
          <UiLink :to="child.url" class="cn-footer-menu__item-link">
            {{ child.name }}
          </UiLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import UiLink from '@/components/ui/UiLink';

interface Props {
  menu: any[];
}

defineProps<Props>();
</script>

<style lang="scss">
.cn-footer-menu {
  --ab-canyon-footer-menu-item-title-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-footer-menu-item-link-color-text: var(
    --ab-canyon-color-neutral-dark
  );

  row-gap: var(--size-3xl);
  flex-wrap: wrap;
  display: flex;
  margin-left: calc(var(--size-lg) * -1);
  margin-right: calc(var(--size-lg) * -1);
  &__item {
    padding-left: var(--size-lg);
    padding-right: var(--size-lg);
    width: 100%;

    @media (min-width: 992px) {
      width: 50%;
    }
    @media (min-width: 1280px) {
      width: 25%;
    }
  }
  &__item-title {
    color: var(--ab-canyon-footer-menu-item-title-color-text);
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  &__item-list {
    margin-top: var(--size-xl);
    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-base);
      }
    }
  }
  &__item-link {
    color: var(--ab-canyon-footer-menu-item-link-color-text);
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
